import React from 'react'
import "./index.scss"

const ErrorMessage = (props) => {
    const {error} = props
    return (
        <span className='error_message'>{error}</span>
    )
}

export default ErrorMessage